import { render, staticRenderFns } from "./HealthCenter.vue?vue&type=template&id=43ae9475&scoped=true&"
import script from "./HealthCenter.vue?vue&type=script&lang=js&"
export * from "./HealthCenter.vue?vue&type=script&lang=js&"
import style0 from "./HealthCenter.vue?vue&type=style&index=0&id=43ae9475&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43ae9475",
  null
  
)

component.options.__file = "HealthCenter.vue"
export default component.exports